var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-row',[_c('b-col',{staticClass:"headerFont"},[_vm._v(" Naturschön - Wunderschön ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }